import Vue from 'vue'
import App from './App.vue'
import router from './router'

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
Vue.use(ElementUI)

import './http/ajax'
import Axios from 'axios'
import './http/ajax'
import store from './store'
import '@vant/touch-emulator';            //加入pc适配
//自定义指令
import dirctives from './utils/directives'
Vue.use(dirctives)

Vue.prototype.$formD = function (obj) {
  const formData = new URLSearchParams();
  Object.keys(obj).forEach((key) => {
    if (obj[key] instanceof Array) {
      obj[key].forEach((item) => {
        formData.append(key, item);
      });
      return;
    }
    formData.append(key, obj[key]);
  });
  return formData;
},
  Vue.config.productionTip = false
Vue.prototype.$axios = Axios

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
